import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_BATTERY_STATUS } from './url-constants';

type SiteBatteryStatusEndpointSpecification = ApiEndpointSpecification;
export const SiteBatteryStatusEndpointSpecification: SiteBatteryStatusEndpointSpecification = {
    url: SITE_BATTERY_STATUS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteBatteryStatusRequestParams',
    requestBodySchemaName: 'SiteBatteryStatusRequestBody',
    okResponseSchemaName: 'SiteBatteryStatusOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteBatteryStatus = Helpers.makeApiRequestFn<
    Types.SiteBatteryStatusRequestParams,
    Types.SiteBatteryStatusRequestBody,
    Types.SiteBatteryStatusOkResponse
>(SiteBatteryStatusEndpointSpecification);
